import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'event_action',
    path: 'data.tags',
    viewPath: props.viewPath,
  })

  let tags = useDataValue({
    context: 'event_action',
    path: 'data.tags',
    viewPath: props.viewPath,
  })

  let tagId = useDataValue({
    context: 'tag',
    viewPath: props.viewPath,
    path: 'id',
  })

  return function onClick() {
    change(tags.filter(({ id }) => id !== tagId))
  }
}
